import { useState } from 'react';
import { ACTION_TYPES, useBudgetUnitSearchDispatch, useBudgetUnitSearchState } from './budget-unit-search-context';
import BudgetUnitAppService from '../../../../application/platform/sge/budget-unit/budget-unit-app-service';
import { useFeedback } from '../../../../hooks/use-feedback';
import { IBudgetUnitAddEditRequest } from '../../../../model/sge/budget-unit/request/budget-unit-add-edit-request';
import { IBudgetUnitResponse } from '../../../../model/sge/budget-unit/response/budget-unit-response';
import { parseNumberInput } from '../../../../utils/format';
import { formatCodeName } from '../../components/code-name-label';

export const useBudgetUnitSearchController = () => {
    const dispatch = useBudgetUnitSearchDispatch();
    const state = useBudgetUnitSearchState();
    const { showSuccess, showError, confirmDelete, withLoading } = useFeedback();
    const [isSaving, setIsSaving] = useState(false);

    // Filtros
    function handleOnChange(e: any) {
        const { name, value } = e.target;
        if (name === 'input-year') {
            dispatch({ type: ACTION_TYPES.updateParameter, payload: { year: parseNumberInput(value) } });
        } else if (name === 'input-search') {
            dispatch({ type: ACTION_TYPES.updateParameter, payload: { search: value || undefined } });
        }
    }

    function handleSearch() {
        dispatch({ type: ACTION_TYPES.triggerSearch });
    }

    function handleClearFilters() {
        dispatch({ type: ACTION_TYPES.updateParameter, payload: { year: undefined, search: undefined } });
        dispatch({ type: ACTION_TYPES.triggerSearch });
    }

    // Cadastro/edição: busca o registro atualizado antes de abrir o formulário
    async function openDrawer(row?: IBudgetUnitResponse) {
        if (!row) {
            dispatch({ type: ACTION_TYPES.openDrawer });
            return;
        }
        try {
            const budgetUnit = await withLoading(() => BudgetUnitAppService.getById(row.id));
            dispatch({ type: ACTION_TYPES.openDrawer, payload: budgetUnit });
        } catch (error: any) {
            showError('Não foi possível carregar a unidade orçamentária', error);
        }
    }

    function closeDrawer() {
        dispatch({ type: ACTION_TYPES.closeDrawer });
    }

    async function handleSave(request: IBudgetUnitAddEditRequest) {
        const editing = state.drawer.record;
        setIsSaving(true);
        try {
            if (editing) {
                await BudgetUnitAppService.edit(editing.id, request);
                showSuccess('Unidade orçamentária atualizada com sucesso!');
            } else {
                await BudgetUnitAppService.add(request);
                showSuccess('Unidade orçamentária adicionada com sucesso!');
            }
            closeDrawer();
            dispatch({ type: ACTION_TYPES.triggerSearch });
        } catch (error: any) {
            showError('Não foi possível salvar a unidade orçamentária', error);
        } finally {
            setIsSaving(false);
        }
    }

    async function removeBudgetUnit(row: IBudgetUnitResponse) {
        try {
            await BudgetUnitAppService.remove(row.id);
            showSuccess('Unidade orçamentária excluída com sucesso!');
            dispatch({ type: ACTION_TYPES.triggerSearch });
        } catch (error: any) {
            showError('Não foi possível excluir a unidade orçamentária', error);
        }
    }

    function handleDelete(row: IBudgetUnitResponse) {
        confirmDelete(`Tem certeza que deseja excluir a unidade orçamentária "${formatCodeName(row)}"?`, () => { removeBudgetUnit(row); });
    }

    return { isSaving, handleOnChange, handleSearch, handleClearFilters, openDrawer, closeDrawer, handleSave, handleDelete };
};
